const autoNgTemplateLoaderTemplate1 = require('./footer.html');

import angular from 'angular';
import { getProductInfo, fullVersion } from '@/shbdeployer/product';

/**
 * Подвал приложения: продукт, компания, версия, ссылки на разделы помощи.
 * Значения берутся из централизованных сведений о продукте.
 */
class FooterController {
  /* @ngInject */
  constructor(StateManager) {
    this.StateManager = StateManager;
  }

  $onInit() {
    this.product = getProductInfo();
    this.year = new Date().getFullYear();
    this.versionLabel = fullVersion(this.product);
  }
}

export const shbFooter = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: FooterController,
};

export default angular.module('shbdeployer.components.footer', []).component('shbFooter', shbFooter).name;
